import httpClient from '../../config/http.client'

const loginPost = (url, body) => httpClient.post(url, body)

export default loginPost
